import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { select } from 'src/app/common/utilities/ngxs-utils';
import { map } from 'rxjs';
import { User } from 'src/app/common/state/user/user.model';
import { UserState } from 'src/app/common/state/user/user.state';
import { FetchSessionData } from 'src/app/private/shared/state/coaching-log/coaching-log.actions';
import { CoachingSessionDTO } from 'src/app/private/shared/dtos/coaching-session.dto';
import { CoachingLogState } from 'src/app/private/shared/state/coaching-log/coaching-log.state';
import { CelebrationsService } from 'src/app/private/shared/services/celebrations/celebrations.service';
import { CelebrationDTO } from 'src/app/private/shared/dtos/celebrations.dto';
import {
  FroalaEnterOutput,
  WysiwygEditorConfig,
} from 'src/app/private/shared/components/wysiwyg-editor/wysiwyg-editor.component';
import { GeneralLogService } from 'src/app/private/shared/services/general/general-log.service';
import { CoachingLogService } from 'src/app/private/shared/services/coaching-log/coaching-log.service';
import { FileDTO } from 'src/app/private/shared/dtos/file.dto';
import { fileDTOFromEvidenceAttachment } from 'src/app/private/shared/helpers/translators/evidence.translators';
import { UploadType } from 'src/app/private/shared/enums/upload-type.enum';
import { LogFileService } from 'src/app/private/shared/services/file/log.file.service';
import { FileUploadComponent } from 'src/app/private/shared/components/file-management/file-upload/file-upload.component';

@Component({
  selector: 'app-general-log-page',
  templateUrl: './general-log-page.component.html',
  styleUrls: ['./general-log-page.component.scss'],
})
export class GeneralLogPageComponent implements OnInit {
  sessionId: number;

  sessionData$ = select(CoachingLogState.getSessionData);

  sessionData: CoachingSessionDTO;

  user: User;

  hasPresentAttendee = true;

  isCoach = false;

  isShadower = false;

  initialContent: string;

  isSaving = false;

  editorConfig: WysiwygEditorConfig;

  uploadType = UploadType.LOG;

  attachments: FileDTO[] | undefined;

  celebrations: CelebrationDTO[] | null = null;

  @ViewChild('uploadComponent') uploadComponent: FileUploadComponent;

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    public coachingService: CoachingLogService,
    private generalLogService: GeneralLogService,
    private celebrationService: CelebrationsService
  ) {
    this.user = this.store.selectSnapshot(UserState.getUser) as User;
  }

  ngOnInit(): void {
    this.route.params.subscribe((url) => {
      this.sessionId = parseInt(url['logId']);
      this.store.dispatch(new FetchSessionData(this.sessionId));

      this.editorConfig = {
        initialContent: this.initialContent,
        useCodox: true,
        docId: this.sessionId.toString(),
        fontFamilySelection: true,
        fontSizeSelection: true,
        paragraphFormatSelection: true,
        editId: `ContentEditor-${this.sessionId}`,
        pastePlain: true,
        enter: FroalaEnterOutput.INSERT_BR,
      };

      this.sessionData$
        .pipe(map((filterFn) => filterFn(this.sessionId)))
        .pipe(
          map((sessionData) => {
            if (sessionData) {
              this.sessionData = sessionData;
              this.initialContent = this.sessionData.sessionNotes;
              if (sessionData.attachments) {
                this.attachments = this.sessionData.attachments?.map(
                  (attachment) => fileDTOFromEvidenceAttachment(attachment)
                );
              }
              setTimeout(() => {
                if (this.sessionId && this.uploadComponent) {
                  (this.uploadComponent.fileService as LogFileService).setLogId(
                    this.sessionId
                  );
                }
              }, 500);
            }
          })
        )
        .subscribe();
    });

    this.celebrationService.getCelebrations().subscribe((res) => {
      if (res) {
        if (res.length > 6) {
          this.celebrations = res.slice(0, 6);
        } else {
          this.celebrations = res;
        }
      }
    });
  }

  updateNotes(newNotes: string) {
    if (this.sessionData.sessionNotes !== newNotes) {
      this.isSaving = true;

      this.generalLogService
        .updateCoachingLog(this.sessionId, newNotes)
        .subscribe(() => {
          this.isSaving = false;
        });
    }
  }
}
